import { render, staticRenderFns } from "./App.vue?vue&type=template&id=67f890f5&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=67f890f5&prod&lang=less"
import style1 from "./App.vue?vue&type=style&index=1&id=67f890f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f890f5",
  null
  
)

export default component.exports